enum PrimaryButtonTheme {
    Dandelion = "dandelion",
    Coral = "coral"
}

export default PrimaryButtonTheme;
